import { useMutation } from '@tanstack/react-query';

import { CreateSharedViewParameters } from '../../../../../../../typings/api/skymap/rest/v0/shared-view';
import { SkyMapAxiosServiceFactory } from '../../../../../services/axios/skymap-axios-service-factory';

type Props = {
  onSuccess: () => void;
};

const useCreateQuery = (props: Props) =>
  useMutation({
    mutationFn: async (form: CreateSharedViewParameters) =>
      SkyMapAxiosServiceFactory.instance.createSharedViewServiceV0().createSharedView(form),
    retry: false,
    networkMode: 'always',
    onSuccess: () => props.onSuccess(),
  });

export { useCreateQuery };
